<script setup lang="ts">
import {
    DropdownMenuSeparator,
    type DropdownMenuSeparatorProps,
} from "radix-vue";

const props = defineProps<DropdownMenuSeparatorProps>();
</script>

<template>
    <DropdownMenuSeparator
        v-bind="props"
        class="-mx-1 my-1 bg-stone-100 dark:bg-stone-800 h-px"
    />
</template>
